var Q = require('q'),
	http = require('core/http'),
	utilities = require('utilities'),
	beatriceDataMap = require('beatrice-data-map'),
	ReadWorksProduct = require('types/ReadWorksProduct'),
	config = require('core/config').resources.media,
	assignmentService = require('./assignmentService'),
	cache = {},
	pending = {};

const alertUtilities = require('utilities/alertUtilities');

const GENERIC_ERROR_MESSAGE = alertUtilities.messages.GENERIC_ERROR_MESSAGE;

var CACHE_BUST;

module.exports = {
	get: function (productId) {
		if (cache[productId]) {
			return Q(cache[productId]);
		}

		if (pending[productId]) {
			var pendingDeferred = Q.defer();

			pending[productId].push(pendingDeferred);

			return pendingDeferred.promise;
		}

		var updateVersion = false;
		var url;
		var endpoint = 'cdn';
		var productIdHasVersion = utilities.productIdHasVersion(productId);

		if (productIdHasVersion) {
			url = (config[endpoint] || config.origin) + '/data/p/' + productId;
		} else {
			var latest = utilities.getProductLatestVersionedId(productId);

			if (latest) {
				url = (config[endpoint] || config.origin) + '/data/p/' + latest;
			} else {
				endpoint = 'origin';
				url = config[endpoint] + '/data/p/' + productId;
				updateVersion = true;
			}
		}

		pending[productId] = [];

		return http
			.get(url, {
				cb: CACHE_BUST
			})
			.then(function (response) {
				return JSON.parse(response.text);
			})
			.catch(function (error) {
				if (error.crossDomain) {
					var params = {
						id: productId
					};

					if (endpoint === 'origin') {
						params.source = 's3';
					} else {
						params.source = 'cf';
					}

					return assignmentService.getProduct(params);
				} else {
					throw error;
				}
			})
			.then(function (result) {
				var product = new ReadWorksProduct(beatriceDataMap.product.serverToClient(result));

				if (updateVersion) {
					utilities.updateLatestProductVersions(product);
				}

				cache[productId] = product;

				pending[productId].forEach(function (d) {
					d.resolve(product);
				});

				return product;
			})
			.catch(function (error) {
				// Only subsequent requests get put in the 'pending' list
				// This catches errors from the above 'catch' and doesn't throw
				//    and doesn't throw or reject if only 1 request was made
				pending[productId].forEach(function (d) {
					d.reject(error);
				});

				if (error.status !== 403) {
					alertUtilities.error(GENERIC_ERROR_MESSAGE);
				}

				//Need to throw to reject initial request as well
				throw error;
			})
			.fin(function () {
				delete pending[productId];
			});
	}
};
